import React, { createContext, useContext, useState, useCallback } from 'react';

const SnackbarContext = createContext(null);

const MAX_SNACKBARS = 3;
const DEFAULT_DURATION = 4000;

export function SnackbarProvider({ children }) {
  const [snackbars, setSnackbars] = useState([]);

  const showSnackbar = useCallback((message, options = {}) => {
    const id = Date.now() + Math.random().toString(36).slice(2, 9);
    const variant = options.variant || 'info';
    const duration = options.duration || DEFAULT_DURATION;

    setSnackbars(prev => {
      const next = [...prev, { id, message, variant, duration }];
      if (next.length > MAX_SNACKBARS) {
        next.shift();
      }
      return next;
    });

    return id;
  }, []);

  const removeSnackbar = useCallback((id) => {
    setSnackbars(prev => prev.filter(s => s.id !== id));
  }, []);

  return (
    <SnackbarContext.Provider value={{ snackbars, showSnackbar, removeSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const ctx = useContext(SnackbarContext);
  if (!ctx) {
    throw new Error('useSnackbar must be used within SnackbarProvider');
  }
  return ctx;
}
